import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { ScrollToSection } from "./components/ScrollToSection";
import { CookieConsent } from "./components/CookieConsent";
import { AppointmentBooking } from "./components/AppointmentBooking";
import { SocialBar } from "./components/SocialBar";
import { Home } from "./pages/Home";
import { PersonalCare } from "./pages/PersonalCare";
import { Childcare } from "./pages/Childcare";
import { Cleaning } from "./pages/Cleaning";
import { Handyman } from "./pages/Handyman";
import { ITSupport } from "./pages/ITSupport";
import { Contact } from "./pages/Contact";
import { Privacy } from "./pages/Privacy";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToSection />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/aides-personne" element={<PersonalCare />} />
            <Route path="/garde-enfant" element={<Childcare />} />
            <Route path="/menage" element={<Cleaning />} />
            <Route path="/bricolage" element={<Handyman />} />
            <Route path="/informatique" element={<ITSupport />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/confidentialite" element={<Privacy />} />
            <Route path="/mentions-legales" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
        <SocialBar />
        <ScrollToTop />
        <AppointmentBooking />
        <CookieConsent />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
